/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var ProductSchemeEnum;

(function (ProductSchemeEnum) {
  ProductSchemeEnum["ACCELERANT"] = "ACCELERANT";
  ProductSchemeEnum["ACCELERANT_RECRUITMENT"] = "ACCELERANT_RECRUITMENT";
  ProductSchemeEnum["RENT_TO_RENT"] = "rent_to_rent";
  ProductSchemeEnum["UCES"] = "UCES";
})(ProductSchemeEnum || (ProductSchemeEnum = {}));